import apiSlice from './api/api';

export const biometricDevicesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all biometric devices
    getBiometricDevices: builder.query({
      query: (activeOnly = false) => ({
        url: '/biometric-devices',
        params: activeOnly ? { activeOnly: true } : {},
      }),
      providesTags: ['BiometricDevices'],
    }),

    // Get all biometric devices with real-time connection status
    getBiometricDevicesWithStatus: builder.query({
      query: (activeOnly = false) => ({
        url: '/biometric-devices/with-status',
        params: activeOnly ? { activeOnly: true } : {},
      }),
      providesTags: ['BiometricDevices'],
    }),

    // Get single device by ID
    getBiometricDevice: builder.query({
      query: (id) => `/biometric-devices/${id}`,
      providesTags: (result, error, id) => [{ type: 'BiometricDevices', id }],
    }),

    // Create or Update device
    saveBiometricDevice: builder.mutation({
      query: (device) => ({
        url: device.id ? `/biometric-devices/${device.id}` : '/biometric-devices',
        method: device.id ? 'PUT' : 'POST',
        body: device,
      }),
      invalidatesTags: ['BiometricDevices'],
    }),

    // Delete device
    deleteBiometricDevice: builder.mutation({
      query: (id) => ({
        url: `/biometric-devices/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['BiometricDevices'],
    }),

    // Test device connection
    testDeviceConnection: builder.mutation({
      query: (id) => ({
        url: `/biometric-devices/${id}/test-connection`,
        method: 'POST',
      }),
    }),

    // Sync attendance from device
    syncDeviceAttendance: builder.mutation({
      query: ({ deviceId, startDate, endDate }) => ({
        url: '/biometric-devices/sync-attendance',
        method: 'POST',
        body: {
          device_id: deviceId,
          ...(startDate && { start_date: startDate }),
          ...(endDate && { end_date: endDate }),
        },
      }),
      invalidatesTags: ['BiometricDevices', 'Attendance'],
    }),

    // Sync attendance from all devices
    syncAllDevicesAttendance: builder.mutation({
      query: () => ({
        url: '/biometric-devices/sync-all',
        method: 'POST',
      }),
      invalidatesTags: ['BiometricDevices', 'Attendance'],
    }),

    // Register user on device
    registerUserOnDevice: builder.mutation({
      query: ({ deviceId, userData }) => ({
        url: `/biometric-devices/${deviceId}/register-user`,
        method: 'POST',
        body: userData,
      }),
    }),

    // Delete user from device
    deleteUserFromDevice: builder.mutation({
      query: ({ deviceId, employeeCode }) => ({
        url: `/biometric-devices/${deviceId}/user/${employeeCode}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetBiometricDevicesQuery,
  useGetBiometricDevicesWithStatusQuery,
  useGetBiometricDeviceQuery,
  useSaveBiometricDeviceMutation,
  useDeleteBiometricDeviceMutation,
  useTestDeviceConnectionMutation,
  useSyncDeviceAttendanceMutation,
  useSyncAllDevicesAttendanceMutation,
  useRegisterUserOnDeviceMutation,
  useDeleteUserFromDeviceMutation,
} = biometricDevicesApi;
